;(function () {
  function initJourneyFurniture(root) {
    var sections = (root || document).querySelectorAll('.journey-furniture');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var navItems = section.querySelectorAll('.journey-furniture__nav-item');
      var connector = section.querySelector('.journey-furniture__line-connector');
      var lineVertical = section.querySelector('.journey-furniture__line-vertical');
      var lineBottom = section.querySelector('.journey-furniture__line-bottom');
      var mobileUnderline = section.querySelector('.journey-furniture__mobile-underline');
      var leftHeadings = section.querySelectorAll('.journey-furniture__left-heading');
      var imageStates = section.querySelectorAll('.journey-furniture__image-state');
      var contents = section.querySelectorAll('.journey-furniture__content');
      var currentIndex = 0;

      if (!navItems.length) return;

      // direction: 1 = going right/forward, -1 = going left/back, 0 = no slide
      function activate(index, direction) {
        var isMobile = window.innerWidth < 990;
        currentIndex = index;
        section.dataset.activeIndex = index;

        navItems.forEach(function (btn, i) {
          var isActive = i === index;
          btn.classList.toggle('journey-furniture__nav-item--active', isActive);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        leftHeadings.forEach(function (heading, i) {
          heading.classList.toggle('journey-furniture__left-heading--active', i === index);
        });

        imageStates.forEach(function (state, i) {
          var isActive = i === index;
          if (isMobile && direction) {
            if (isActive) {
              // Incoming: start off-screen in swipe direction, then animate to 0
              state.style.transition = 'none';
              state.style.transform = 'translateX(' + (direction * 100) + '%)';
              state.offsetHeight; // force reflow
              state.style.transition = '';
              state.style.transform = 'translateX(0)';
            } else if (state.classList.contains('journey-furniture__image-state--active')) {
              // Outgoing: slide out in opposite direction
              state.style.transform = 'translateX(' + (direction * -100) + '%)';
            }
          } else if (!isMobile) {
            state.style.transform = '';
          }
          state.classList.toggle('journey-furniture__image-state--active', isActive);
        });

        contents.forEach(function (content, i) {
          var isActive = i === index;
          if (isMobile && direction) {
            if (isActive) {
              content.style.transition = 'none';
              content.style.transform = 'translateX(' + (direction * 100) + '%)';
              content.offsetHeight;
              content.style.transition = '';
              content.style.transform = 'translateX(0)';
            } else if (content.classList.contains('journey-furniture__content--active')) {
              content.style.transform = 'translateX(' + (direction * -100) + '%)';
            }
          } else if (!isMobile) {
            content.style.transform = '';
          }
          content.classList.toggle('journey-furniture__content--active', isActive);
        });

        positionLine(index);
      }

      function positionLine(index) {
        var btn = navItems[index];
        if (!btn) return;

        var nav = btn.parentElement;
        var grid = section.querySelector('.journey-furniture__grid');
        if (!grid || !nav) return;
        var gridRect = grid.getBoundingClientRect();
        var navRect = nav.getBoundingClientRect();
        var btnRect = btn.getBoundingClientRect();

        // Connector: from 30% of grid width to the active button's right edge
        var connectorStart = gridRect.width * 0.30;
        var btnRightRelative = btnRect.right - gridRect.left;
        var connectorWidth = btnRightRelative - connectorStart;

        // Align to nav bottom (where underline would sit)
        var navBottom = navRect.bottom - gridRect.top;

        if (connector) {
          connector.style.top = navBottom + 'px';
          connector.style.width = Math.max(0, connectorWidth) + 'px';
        }

        if (lineVertical) {
          lineVertical.style.top = navBottom + 'px';
          if (lineBottom) {
            var bottomTop = lineBottom.offsetTop;
            lineVertical.style.height = (bottomTop - navBottom) + 'px';
          }
        }

        // Mobile underline: from -100vw to right edge of active button (relative to nav)
        if (mobileUnderline) {
          var btnRightInNav = btn.offsetLeft + btn.offsetWidth;
          mobileUnderline.style.width = 'calc(100vw + ' + btnRightInNav + 'px)';
        }
      }

      // Desktop: mouseenter switches state
      navItems.forEach(function (btn, i) {
        btn.addEventListener('mouseenter', function () {
          var dir = i > currentIndex ? 1 : i < currentIndex ? -1 : 0;
          activate(i, dir);
        });
        // Mobile: click/tap
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          var dir = i > currentIndex ? 1 : i < currentIndex ? -1 : 0;
          activate(i, dir);
        });
      });

      // Touch swipe to switch states on mobile
      var touchStartX = 0;
      var touchEndX = 0;
      var swipeThreshold = 50;

      section.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      section.addEventListener('touchend', function (e) {
        touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) < swipeThreshold) return;

        var maxIdx = navItems.length - 1;

        if (diff > 0 && currentIndex < maxIdx) {
          activate(currentIndex + 1, 1);
        } else if (diff < 0 && currentIndex > 0) {
          activate(currentIndex - 1, -1);
        }
      }, { passive: true });

      // Initial state
      activate(0, 0);

      // Reposition line on resize (debounced)
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          positionLine(currentIndex);
        }, 100);
      });

      // Reposition after fonts load
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          positionLine(currentIndex);
        });
      }
    });
  }

  // Init on page load
  initJourneyFurniture();

  // Re-init in theme editor
  document.addEventListener('shopify:section:load', function (event) {
    initJourneyFurniture(event.target || document);
  });
})();
